export const casinoGamesTreeQueryKey = (search: string) =>
  ["casinoConfiguration", "games", "tree", search] as const;

export const casinoGamesTreeGroupQueryKey = (
  provider: string,
  sub: string,
  search: string,
) =>
  ["casinoConfiguration", "games", "tree-group", provider, sub, search] as const;

export const CASINO_CONFIGURATION_GAMES_SCOPE_QUERY_KEY = [
  "casinoConfiguration",
  "games",
] as const;
